module.exports = __webpack_public_path__ + "static/media/头图@2x.baf7cd07.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_172/images/头图@2x.png
// module id = 1598
// module chunks = 0